import * as React from 'react';
import { History } from 'history';
import Model from './user-model';
import BaseUpload from '../base/base-upload.component';
import PersonalinfoCreate from '../personalinfo/personalinfo-create.component';
import AppService from '../../services/app.service';

interface IProps {  
  history: History;
  caption?: string;
  dataset: Array<any>;
  onError?: (data: any) => void;
  onSave?: (data: any) => void;
  disableUploadButton?: boolean;
  disableBackButton?: boolean;
}

interface IState {
  datarowPersonalinfo: any,
  save: boolean;
}

export default class UserUpload extends React.Component<IProps, IState> {
  constructor(props:IProps) {
      super(props);  
      this.state = {
        datarowPersonalinfo: null,
        save: false,
      }
  }

  private defaultValue = (data: any) => {
    const email = Model.getEmailApp(data?.useremail); 
    const useremailmasking = AppService.emailMasking(data.useremail);
    const password = 'password123';
    return {...data, email: email, username: email, useremailmasking: useremailmasking, password: password, passwordConfirmation: password}
  }

  private onError = async(data: any) => {
    if (data) await this.props.onError?.(data);
  }

  private onSave = async(data: any) => {
    if (data.id) await this.setState({datarowPersonalinfo: {user: data.id, name: data.name, description: data.name, email: data.useremail}, save: true});
  }

  private onErrorPersonalinfo = (data: any) => {
    if (data) this.setState({save: false});
  }

  private onSavePersonalinfo = (data: any) => {
    if (data) {
      this.props.onSave?.(data)
      this.setState({save: false});
    }
  }

  public render(): React.ReactNode {
    return (
      <>
      <BaseUpload caption={this.props.caption} endPoint={Model.endPointAuth+ '/local/register'} model={Model} dataset={this.props.dataset} defaultValue={this.defaultValue} onError={this.onError} onSave={this.onSave} disableUploadButton={this.props.disableUploadButton} disableBackButton={this.props.disableBackButton} />
      <PersonalinfoCreate history={this.props.history} personalinfotypeType='customer' datarow={this.state.datarowPersonalinfo} save={this.state.save} onError={this.onErrorPersonalinfo} onSave={this.onSavePersonalinfo} disableView />                            
      </>
    );
  }
}
